import { app } from '../../../../../app';
import { Controller } from './generate-login-code.controller';

app.component('companyManageApplicationUsersGenerateLoginCode', {
    bindings: {
        groupId: '<',
        appId: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./generate-login-code.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/users/generate-login-code/generate-login-code.component.js